var $ = jQuery;
$(document).ready(function(){

    if ($('.custom-popup').length > 0) {
        $(".custom-popup .mfp-close.scissors-close").click(function(){
            $('.custom-popup').removeClass('visible');
            window.sessionStorage.setItem('popup-shown', 'true')
        });

        if (!window.sessionStorage.getItem('popup-shown')) {
            setTimeout(function () {
                $('.custom-popup').addClass('visible');
                window.sessionStorage.setItem('popup-shown', 'true')
            }, 2000)
        }
    }

    jQuery(".faq-title").click(function(){
      if( jQuery(this).hasClass('active') ){
        jQuery(this).removeClass("active").closest('.faq-block').find('.faq-desc').slideUp(200);
      }
      else{ jQuery(this).addClass("active").closest('.faq-block').find('.faq-desc').slideDown(200);
      }
    });
    $(document).on("click",'.remove-device',function(){
        var $token = $(this).attr("data-token");
        var $this = $(this);
        var $mainDeviceContainer = $this.parents('.border-bottom');
        jQuery.ajax({
            type: "post",
            url: localize_object.ajaxurl,
            data: {
                action : 'remove_device',
                token : $token
            },
            beforeSend: function() {
                // setting a timeout
                $mainDeviceContainer.addClass('processing')
            },
            success: function(response){
                if(response.status == 'success')
                {
                    $('#active-device-tot').html(response.activeDevice);
                    $mainDeviceContainer.fadeOut();
                    $mainDeviceContainer.remove();
                }
            },
            error: function(){
                alert('Something went wrong. Please try again letter')
                $mainDeviceContainer.removeClass('processing');
            }
        });
    });

    $(document).on("click",'.init-user-payment',function() {
        $(this).addClass('inactive');
        jQuery.ajax({
            type: "post",
            url: localize_object.ajaxurl,
            data: {
                action : 'init_user_payment'
            },
            success: function(response){
                window.location.reload()
            }
        });
    });

    //live search result
    var ajaxRequest = false;
    var $searchgroup = $('.woocommerce-product-search .search-button-group');
    var $searchInput = $('.woocommerce-product-search #woocommerce-product-search-field-1');
    $(document).on('input','.woocommerce-product-search #woocommerce-product-search-field-1',function(){
        var $val = $(this).val();
        if($val.length >= 3)
        {
            if ( ajaxRequest ) {
                ajaxRequest.abort();
            }
            if ( ajaxRequest ) {
                ajaxRequest.abort();
            }
           $searchgroup.addClass('text-changed');
           ajaxRequest = $.ajax({ 
               type: "post",
               url: localize_object.ajaxurl,
               data: {
                   action : 'search_input_product',
                   s : $val
               },
               beforeSend: function() {
                   $searchgroup.addClass('et-loader')
               },
               success: function(response){
                   if(response.status == 'success')
                   {
                       $('.enter-hint').remove();
                       $searchgroup.removeClass('et-loader')
                       $('.autocomplete-wrapper').html(response.html);
                   }
               }
          });
        }
        else
        {
           $searchgroup.removeClass('text-changed');
           $('.autocomplete-wrapper').html("");
        }
   });
   $(document).on('click','.woocommerce-product-search .search-clear',function(){
       $searchgroup.removeClass('et-loader');
       $searchgroup.removeClass('text-changed');
       $searchInput.val('');
       $searchInput.trigger('input');
   })
   /* My Book tabing */
   $(document).on('click', '#mybook-nav a', function(e){
        e.preventDefault();
        if(!$(this).hasClass('active'))
        {
            $('#mybook-nav a').removeClass('active')
            $('.tab-content').removeClass('active')
            $(this).addClass('active');
            var $href = $(this).attr('href');
            if($href)
            {
                $($href).addClass('active')
            }
        }
    });
   /* Order tabing */
   $(document).on('click', '#order-nav a', function(e){
        e.preventDefault();
        if(!$(this).hasClass('active'))
        {
            $('#order-nav a').removeClass('active')
            $('.tab-content').removeClass('active')
            $(this).addClass('active');
            var $href = $(this).attr('href');
            if($href)
            {
                $($href).addClass('active')
            }
        }
    });
    if(jQuery(window).width() < 768)
    {
        $('[data-toggle="popover"]').popover({
            trigger: 'click',
            placement: 'auto'
        });
    }
    else
    {
        $('[data-toggle="popover"]').popover({
            trigger: 'hover'
        });
    }
    //application popup close
	$(document).on('click', '.close-app-popup', function(){
        document.cookie = "app-popup=1";
        $('.footer-app-bar').hide();
        $('.footer-anroid-bar').hide();
        $('body').removeClass('app-popup-bar');
	});
  
  //subscription cancel confirmation
  $(".subscription-actions-last a.cancel").on("click", function(e) {
      e.preventDefault();
      $("#disconnect-modal").show();
  });

  $(".disconnect-yes-btn.reason-check").on("click", function(e) {
      e.preventDefault();
      var href = $(this).attr('href');
      if ($('#reason').val() === '') {
          $('#reason').css('border', '1px solid red');
      } else {
          var data = {
              'action' : 'submit_reason',
              'reason' : $('#reason').val()
          };

          $.get(localize_object.ajaxurl, data, function(response){
              if (response.success) {
                  window.location = href
              }
          });
      }
  });
  //check our has hash value
  if(window.location.hash) {
    var hash = window.location.hash;
    if($(hash) && $(hash).parents('.tab-content'))
    {
      $('a[href='+hash+']').click();
    }  
  }
   //Logout active device
  $(document).on("click", ".logout-btn-device", function(e) {
    $("#disconnect-modal").show();
  });
  $(document).on("click", ".disconnect-popup-close", function(){
    $("#disconnect-modal").hide();
  });
  $(document).on("click", ".disconnect-no-btn", function(){
    $("#disconnect-modal").hide();
  });
  $(".home-slick-slider").slick({
    slidesToShow: 1,
    infinite:false,
    slidesToScroll: 1,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
  });  
});